export const getRows = (data, currPage, recordsPerPage) => {
  const recordsForCurrPage = data.filter((d, idx) => {
    const start = currPage * recordsPerPage;
    const end = (currPage + 1) * recordsPerPage;
    return idx >= start && idx < end;
  });
  return recordsForCurrPage;
};
